"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getFamilyAverageMonthlyNetIncome;

var _lodash = require("lodash");

function getFamilyAverageMonthlyNetIncome(data) {
  var householdMonthlyIncome = ((0, _lodash.get)(data, 'incomeScheduleI.debtor1.monthlyIncome') || 0) + ((0, _lodash.get)(data, 'incomeScheduleI.debtor2') != null ? (0, _lodash.get)(data, 'incomeScheduleI.debtor2.monthlyIncome') || 0 : 0);
  var governmentAssistance = ((0, _lodash.get)(data, 'incomeScheduleI.debtor1.nonEmploymentIncome.otherGovAssistance') || 0) + ((0, _lodash.get)(data, 'incomeScheduleI.debtor2') != null ? (0, _lodash.get)(data, 'incomeScheduleI.debtor2.nonEmploymentIncome.otherGovAssistance') || 0 : 0);
  return householdMonthlyIncome - governmentAssistance;
}